import React from 'react';
import ReactDOM from 'react-dom';
import App from './routes.js';
import 'flexboxgrid/css/flexboxgrid.css';
import './styles/app.css';

ReactDOM.render(
        <App id="App" />,
        document.getElementById('App'));

export default App;